export default __webpack_public_path__ + "static/media/project-info-btn.5e331a31.svg";